<template>
    <div class="container-fluid" v-if="school">
        <div class="row justify-content-between">
            <div class="col">
                <h4>{{school.name}}> Хичээлүүд</h4>
            </div>
      
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="row">
                    <div class="col col-expand">
                        <h6 class="m-0 font-weight-bold text-primary">Хичээлийн жагсаалт</h6>
                    </div>
                    <div class="col col-auto">
                        <div class="col-auto">
                            <!-- <div @click="$router.push({ 'name':'ILessonAdd' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm mr-2" style="cursor:pointer">Хичээл нэмэх</div> -->
                            <div @click="$router.push({ 'name':'ILessonAddGroup' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm" style="cursor:pointer">Хичээл багцалж нэмэх</div>
                        </div>
                    </div>
                 
                </div>
            </div>
            <div class="card-body">

                <div class="row">
                    <div class="col d-flex flex-row my-3" v-if="departments && departments.length>0">
                        <div style="cursor:pointer" class="badge p-2 mr-2" @click="selectedDepartments=[];search();"  v-bind:class="[!selectedDepartments || (selectedDepartments && selectedDepartments.length==0) ? 'badge-success' : 'badge-light']">Бүгд</div>
                        <div style="cursor:pointer" class="badge p-2 mr-2" @click="searchValue=null; toggleDepartmentFilter(department, selectedDepartments, 'index', true, 10)" v-for="department in departments" v-bind:class="[isInDepartmentFilter(department, selectedDepartments, 'index')==true ? 'badge-success' : 'badge-light']">{{department.name}} анги</div>

                    </div>

                    <div class="col">
                       
                        <div class="input-group">
                        <input type="text" class="form-control bg-light border-1" placeholder="Хайx үгээ оруулан xайx товчийг идэвxжүүлнэ үү." 
                            aria-label="Search" aria-describedby="basic-addon2" v-model="searchValue"
                                v-on:keyup.enter="search()">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="search()">
                            <i class="fas fa-search fa-sm"></i>
                            </button>
                        </div>
                        </div>
                     
                    </div>
                    
                </div>
                <hr/>
                <div >
                    <div  class="row " v-if="categories && categories.length>0">
                        <div style="cursor:pointer" class="my-2 badge p-2 mr-2" @click="selectedCategories=[];"  v-bind:class="[!selectedCategories || (selectedCategories && selectedCategories.length==0) ? 'badge-success' : 'badge-light']">Бүгд</div>
                        <div style="cursor:pointer" class="my-2 badge p-2 mr-2" @click="toggleDepartmentFilter(category, selectedCategories, 'id', false, 100)" v-for="category in categories" v-bind:class="[isInDepartmentFilter(category, selectedCategories, 'id')==true ? 'badge-success' : 'badge-light']">{{category.name}}</div>

                    </div>
                    
                </div>
   
                <div class="table-responsive mt-3" v-if="teachers!=null && teachers.length>0">
                    <table class="table table-sm table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Хичээл</th>

                                <th>Анги</th>
                                <th>Багш</th>
                                <th>Төрөл</th>
                                <th>Ангиар/Группээр</th>
                                <th>Үзүүлэлт</th>
                                <th>Үйлдэл</th>
                            </tr>
                        </thead>

                        <tbody v-for="(category, cindex) in categories" v-if="(!selectedCategories) || (selectedCategories && selectedCategories.length==0) || (selectedCategories && selectedCategories.length>0 && isInDepartmentFilter(category, selectedCategories, 'id')==true ) " >
                            <tr v-for="(lesson, index) in category.lessons" v-if="category.lessons && category.lessons.length>0" >
                                <td style="text-align: center; vertical-align: middle;" class="font-weight-bold" v-if="index==0" v-bind:rowspan="category.lessons.length">{{cindex+1}}.
                                    <span >{{category.name}}</span>
                                    
                                </td>
                      
                             
                                <td>
                                    {{index+1}}.  

                                    {{lesson.name}}
                                    <span class="font-weight-bold" v-if="lesson.classNos && lesson.classNos.length>0">  /{{lesson.classNos[0]}} анги/</span>
                                    <span class="ml-5 badge badge-success" v-if="lesson.typeDetail">
                                        {{lesson.typeDetail.name}}
                                    </span>
                                    <ul v-if="lesson.groups && lesson.groups.length>0">
                                        <li style="cursor:pointer" class="text-primary" v-for="group in lesson.groups" @click="$router.push({ name: 'IGroupStudents', params: { schoolId: schoolId, departmentId: group.department.id, programId: group.program.id} })">
                                            <span v-if="group.departmentName">{{group.departmentName}}</span>
                                            <span v-else>-</span>
                                            /
                                            <span v-if="group.programName">{{group.programName}}</span>
                                            <span v-else>-</span>
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <div class= "text-primary" style="cursor:pointer" v-if="lesson.teachers && lesson.teachers.length>0"  @click="$router.push({ name:'TeacherLessons', params:{schoolId:schoolId, teacherPath: lesson.teachers[0].reference.path} })">
                                        <span v-if="lesson.teachers">
                                            <span v-if="lesson.teachers[0].lastName && lesson.teachers[0].lastName.length>0">{{lesson.teachers[0].lastName[0]}}.</span>
                                        </span>
                                        <span v-if="lesson.teachers">
                                            {{lesson.teachers[0].firstName}}    
                                        </span>

                                        
                                    </div>
                                </td>
                                                              <td>
                                    <span class="badge badge-success" v-if="category.typeDetail.id=='zaaval'">{{category.typeDetail.name}}</span>
                                    <span class="badge badge-warning" v-else>{{category.typeDetail.name}}</span>
                                </td>
                                <td>
                                   <span v-if="lesson.isGroup" class="badge badge-danger">группээр</span>
                                   <span v-else class="badge badge-primary">ангиар</span>     
                                </td>
                                <td>
                                    <div  class="row">
                                        <div class="col" v-if="lesson.procent">
                                            <div class="progress">
                                                <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+lesson.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{lesson.procent}} %</div>
                                            </div>
                                        </div>
                                        <div class="col" v-else>
                                            <div class="progress">
                                                <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                                            </div>
                                        </div>
                                    </div>

                                </td>

                                <td>
                                    <button class="btn btn-primary btn-sm mr-2" @click="$router.push({ name:'SLessonDetail', params:{ schoolId: schoolId, lessonId: lesson.id } })">харах</button>
                                    <button class="btn btn-warning btn-sm" @click="$router.push({ name: 'ILessonEdit', params: { lessonId: lesson.id, schoolId: schoolId, setTeacher:true} })">засах</button>
                                </td>
                            </tr>
                            <tr v-else >
                                <td colspan="5">Одоогоор </td>
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getLessonsData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                        <button v-else type="button" class="btn btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Өгөгдлийг дуудаж байна...
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
            </div>
        </div>

        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:30,
               school:null,
               departments:[],
               selectedDepartments:[],
               categories:[],
               selectedCategories:[]

            }
        },
        props: {
            schoolId: { 
                required: true,
            },
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            async _getData(){
                this.loading=true;
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school;
                    this.categories=[];
                    this.teachers=[];
                    var categorySnapshot= await schoolDoc.ref.collection("categories").orderBy("index").get();
                    if(categorySnapshot && !categorySnapshot.empty){
                        for(const categoryDoc of categorySnapshot.docs){
                            let category=categoryDoc.data();
                            category.id=categoryDoc.id;
                            category.ref=categoryDoc.ref;
                            category.lessons=[];
                            this.categories.push(category);
                        }

                        await this.getLessonsData();
                    }

                    schoolDoc.ref.collection("departments").orderBy("index").get().then(querySnapshot=>{
                        this.departments=[];
                        querySnapshot.docs.forEach(value=>{
                            if(value.exists){
                                let object=value.data();
                                object.id=value.id;
                                object.ref=value.ref;
                                this.departments.push(object);
                            }
                        })
                    });
                }
                this.loading=false;
                
            },
    
            async getLessonsData(){

                // if(this.last==false){
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/lessons");
                    
                    if(this.searchValue && this.searchValue!='' && this.searchValue.length>2){
                       query=query.where("searchTags", "array-contains", this.searchValue); 
                    }
                    else{
                        if(this.selectedDepartments && this.selectedDepartments.length>0){
                            query=query.where("classNos", "array-contains-any", this.selectedDepartments);
                        }
                    }
                    if(this.sele)
                    query=query.orderBy("createdAt", "desc");
                    // if(this.lastVisible==null)
                    // {

                    // }
                    
                    // else
                    //     query=query.startAfter(this.lastVisible);

                    
                    // query=query.limit(this.pageSize);
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        for(const doc of documentSnapshots.docs){
                            let object=doc.data()
                            object.id = doc.id;
                            object.procent=0;
                  
                            // object.teacherData=null;
                            if(object && object.numberOfUnderstand && object.numberOfTotalStatus){
                                object.procent=(object.numberOfUnderstand*100/object.numberOfTotalStatus).toFixed(2)
                            }
                            // if(object.teacher){
                            //     object.teacher.get().then(tdoc=>{
                            //         if(tdoc.exists){
                            //             object.teacherData=tdoc.data();
                            //         }
                            //     });
                            // }
                            if(object.category && object.category.id){
                                for(const category of this.categories){
                                    if(category && category.id && category.id==object.category.id){
                                        category.lessons.push(object);
                                        break;
                                    }
                                }
                            }
                            this.teachers.push(object);
                        }
                   
                        // if(documentSnapshots.size!=this.pageSize)
                        //     this.last=true;
                    }
                    this.loading=false;
                // }
               
            },

            search(){
                this.lastVisible=null;
                this.last=false;
                this.teachers=[];
                for(const category of this.categories){
                    category.lessons=[];
                        
                }

                this.getLessonsData();
    
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/categories").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },
            toggleDepartmentFilter(department, list, prop, search, limit){
                if(this.isInDepartmentFilter(department, list, prop)==true){
                    if(prop)
                        this.removeFromDepartmentFilter(department, list, prop);
                    else 
                        this.removeFromDepartmentFilter(department, list);
                }
                else{
                    if(limit && limit>0){
                        if(list.length>=limit){
                            list.splice(0,1);
                        }
                    }
                    else{
                        if(list.length>=10){
                            list.splice(0, 1);    
                        }
                    }
                    if(prop)
                        list.push(department[prop]);
                    else
                        list.push(department.index);
                }
                if(search && search==true)
                    this.search();
            },
            isInDepartmentFilter(department, list, prop){
                var exists=false;
                for(const current of list){
                    if(prop){
                        if(current && current==department[prop]){
                            exists=true;
                            break;
                        }
                    }
                    else
                        if(current && current==department.index){
                            exists=true;
                            break;
                        }
                }
                return exists;
            },
            removeFromDepartmentFilter(department, list, prop){
                var exists=false;
                var index=0;
                var i=0;
                for(const current of list){
                    if(prop){
                        if(current && current==department[prop]){
                            exists=true;
                            index=i;
                            break;
                        }
                    }
                    else 
                        if(current && current==department.index){
                            exists=true;
                            index=i;
                            break;
                        }
                    i++;
                }
                if(exists && exists==true){
                    list.splice(index, 1);
                }
            },
            async check(){
                var lessonSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").get();
                // for(const lessonDoc of lessonSnapshot.docs){
                //     if(lessonDoc.exists && lessonDoc.data().groups && lessonDoc.data().groups){
                //         for(const groupData of lessonDoc.data().groups){
                //             if(groupData){
                //                 var updateObject={};
                //                 if(groupData.program && groupData.program.id){
                //                     updateObject.programIds=fb.firestore.FieldValue.arrayUnion(groupData.program.id);
                //                     updateObject.programs=fb.firestore.FieldValue.arrayUnion(groupData.program);
                //                 }
                //                 if(groupData.departmentName){
                //                     var indexNo=parseInt(groupData.departmentName);
                //                     updateObject.classNos=fb.firestore.FieldValue.arrayUnion(indexNo);
                //                 }
                //                 if(groupData.department){
                //                     updateObject.departments=fb.firestore.FieldValue.arrayUnion(groupData.department);
                //                 }
                //                 await lessonDoc.ref.update(updateObject);
                //             }
                //         }
                //     }
                // }
                for(const lessonDoc of lessonSnapshot.docs){
                    if(lessonDoc.exists){
                        var tags=[];
                        if(lessonDoc.data().name){
                            tags.push(this.capitalize(lessonDoc.data().name));
                            tags.push(lessonDoc.data().name);
                            tags.push(lessonDoc.data().name.toLowerCase());
                            var arr=lessonDoc.data().name.split(" ");
                            if(arr && arr.length>0){
                                for(const word of arr){
                                    tags.push(this.capitalize(word));
                                    tags.push(word);
                                    tags.push(word.toLowerCase());
                                }
                            }
                        }
                        if(lessonDoc.data().teachers && lessonDoc.data().teachers.length>0){
                            for(const teacher of lessonDoc.data().teachers){
                                if(teacher){
                                    if(teacher.firstName){
                                        tags.push(this.capitalize(teacher.firstName));
                                        tags.push(teacher.firstName);
                                        tags.push(teacher.firstName.toLowerCase());
                                    }
                                    if(teacher.lastName){
                                        tags.push(this.capitalize(teacher.lastName));
                                        tags.push(teacher.lastName);
                                        tags.push(teacher.lastName.toLowerCase());
                                    }
                                }
                            }
                        }
                        if(tags && tags.length>0){
                            lessonDoc.ref.update({searchTags: tags});
                        }
                        
                    }
                }
                console.log("DONE");
            },
            capitalize(s)
            {   
                if(s && s!='')
                    return s && s[0].toUpperCase() + s.slice(1);
                return null;
            }

  
        },
        created() {

            this.teachers=[];
            this._getData();
            // this.check();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
